<template>
  <v-card
    tile
    outlined
    class
    height="100%"
    @click="elegirRestaurante(obj)"
    v-ripple="{ class: `light-blue--text` }"
  >
    <v-img
      class="white--text align-end bg"
      height="200px"
      src="../../assets/img/fondoFicha.png"
      :style="{ backgroundImage: 'url(' + obj.imagenListado + ')' }"
    >
      <v-card-title class="body-2 pa-2" v-if="obj.cocinas">
        <v-icon color="white" class="body-2 mr-1">mdi-star-outline</v-icon>
        {{formatCocinas}}
      </v-card-title>
    </v-img>
    <v-card-title class="pa-2 pb-0 subtitle-1 font-weight-medium">
      <span class="text-truncate text-capitalize ma-0 pa-0 py-0">{{obj.nombre}} - {{obj.nombreRest}}</span>
    </v-card-title>
    <v-card-text class="d-flex flex-column pa-0 ma-0 pb-8">
      <v-container class="pa-0 ma-0">
        <!-- <v-row v-if="obj.telefono">
					<v-col class="py-1 pl-1 pr-0 d-flex align-center" cols="2">
						<v-icon color="black" class="body-2">mdi-phone</v-icon>
					</v-col>
					<v-col class="py-1 px-0" cols="10">
						<span class="body-2">{{ formatedPhone(obj.telefono) }}</span>
					</v-col>
        </v-row>-->
        <v-row class="ma-0 pa-0" v-if="obj.direccion">
          <v-col class="pa-2 pt-0 ma-0" cols="12">
            <span class="body-2">{{ obj.direccion }}</span>
          </v-col>
        </v-row>
        <!-- <v-row v-if="obj.distancia">
					<v-col class="py-1 pl-1 pr-0 d-flex align-center" cols="2">
						<v-icon color="black" class="body-2">mdi-map-marker</v-icon>
					</v-col>
					<v-col class="py-1 px-0" cols="10">
						<span class="body-2">A {{formatedDistancia(obj.distancia)}} de ti</span>
					</v-col>
				</v-row>
				<v-row v-if="obj.recargo">
					<v-col class="py-1 px-0" cols="12">
						<span class="body-2">Precio:{{ obj.recargo }} €</span>
					</v-col>
        </v-row>-->
      </v-container>
    </v-card-text>
    <v-card-actions class="pa-2" style="bottom: 0px;position: absolute;width: 100%;">
      <v-alert
        v-if="obj.distancia"
        tile
        dense
        class="black--text body-2 pa-1 px-2 ma-0 mr-2"
        color="grey lighten-4"
      >A {{formatedDistancia(obj.distancia)}}</v-alert>

      <div v-if="formaEnvio == 'recoger'">
        <v-alert
          tile
          dense
          class="green--text text--darken-4 body-2 pa-1 px-2 ma-0"
          v-if="t_recogida"
          color="green lighten-4"
        >
          Recogida disponible
          <span>: {{t_recogida}} min.</span>
        </v-alert>
        <v-alert
          tile
          dense
          class="black--text body-2 pa-1 px-2 ma-0"
          color="grey lighten-4"
          v-else
        >Recogida no disponible</v-alert>
      </div>

      <div v-if="formaEnvio == 'domicilio'">
        <v-alert
          tile
          dense
          class="green--text text--darken-4 body-2 pa-1 px-2 ma-0"
          v-if="t_domicilio"
          color="green lighten-4"
        >Tiempo estimado: {{t_domicilio}} min.</v-alert>
      </div>

      <!-- <v-alert
				tile
				dense
				class="pa-1 ma-0"
				width="110"
				v-if="!obj.mapeoNeoRest"
				type="warning">
				Mapeo
				</v-alert>
				<v-alert
				tile
				dense
				class="pa-1 ma-0"
				width="110"
				v-if="obj.mapeoNeoRest"
				type="success">
				Mapeo
      </v-alert>-->
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  restSinNegocio,
  formatearCocinas
} from "@/utils/restaurantes.utils.js";
import { horarios } from "@/utils/horarios.class";
import { mapState, mapGetters } from "vuex";
export default {
  name: "restaurant-card",
  props: {
    obj: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      imagenFondo: "https://cdn.vuetifyjs.com/images/cards/cooking.png"
    };
  },
  computed: {
    ...mapState({
      formaEnvio: state => state.pedido.activePedido.forma_envio,
      addressObject: state => state.pedido.addressObject,
      navigatorLocation: state => state.pedido.navigatorLocation,
      activeRest: state => state.pedido.restaurantePedido,
      cocinas: state => state.restaurante.cocinas
    }),
    // domicilio() {
    //   return this.obj.horariosComputados
    //     ? this.obj.horariosComputados[0]
    //     : false;
    // },
    // recogida() {
    //   return this.obj.horariosComputados
    //     ? this.obj.horariosComputados[1]
    //     : false;
    // },
    t_domicilio() {
      return this.obj.tiempoDomicilio ? this.obj.tiempoDomicilio : false;
    },
    t_recogida() {
      return this.obj.tiempoRecogida ? this.obj.tiempoRecogida : false;
    },
    apertura() {
      return this.obj.horariosComputados
        ? this.obj.horariosComputados[2]
        : false;
    },
    formatCocinas() {
      let res = [];
      if (this.obj.cocinas.length > 0 && this.cocinas.length > 0) {
        res = formatearCocinas(this.obj.cocinas, this.cocinas);
      }

      return res;
    }
  },
  methods: {
    /*
		isNear(rest) {
			let _vue = this;
			let nearRest = this.distanciasRestaurantes.splice(0, this.restaurantsLimit);
			
			let index = nearRest.find(function(e){
					return e.slug == rest
				})

			console.log(index)
			return rest;
		},*/
    formatedPhone(phone) {
      let p1 = phone.toString();
      let p2 =
        "+34" +
        " " +
        p1.substring(0, 3) +
        " " +
        p1.substring(3, 3) +
        " " +
        p1.substring(6, 3);
      return p2;
    },
    formatedDistancia(distancia) {
      let d = parseFloat(distancia);
      let msj;
      if (distancia < 1) {
        msj = (d * 1000).toFixed(0) + " metros ";
      } else {
        msj = d.toFixed(0) + " km ";
      }
      return msj;
    },
    elegirRestaurante(data) {
      this.$store
        .dispatch("pedido/elegirRestaurante", data.idRest)
        .then(e => {})
        .catch(err => {
          console.log(err);
        });
    },
    abiertoRecogida(data) {
      if (data.horarios) {
        let timetable = new horarios(data.horarios);
        return timetable.abiertoHoy("domicilio");
      } else {
        return false;
      }
    },
    abiertoReparto(data) {
      if (data.horarios) {
        let timetable = new horarios(data.horarios);
        return timetable.abiertoHoy("recoger");
      } else {
        return false;
      }
    }
  },
  updated() {},
  mounted() {}
};
</script>

<style scoped>
.bg {
  background-repeat: no-repeat;
  background-size: cover;
  background-color: white;
  height: 200px;
}
</style>